module.exports = {
    etherscan: {
        url: `https://www.etherscan.io/address`
    },
    api: {
        game_url: `https://api-lok-beta.leagueofkingdoms.com/api`,
        stat_url: `https://api-stats.leagueofkingdoms.com/api`,
        //stat_url: `https://192.168.12.26:8888/api`,
        nft_url: `https://lok-nft.leagueofkingdoms.com/api`,
        //nft_url: `http://192.168.12.26:9999/api`,
    },
    web: {
        url: `https://www.leagueofkingdoms.com`
    }
}